module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av82-4a3415167df40eb7abef637809d0a352.jpg";